module.exports = {
  siteUrl: 'https://www-stage.zoopay.com',
  serverUrl: 'https://www-stage-api.zoopay.com',
  gaEnabled: false,
  redirectAfterEnquiryTimeout: 10000,
}
